// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import FamilyNew from '../_raw/service/icon_family_new.svg';
import withIconProps from '../withIconProps';

export default withIconProps(FamilyNew);
